import { render, staticRenderFns } from "./DeletedUsersPage.vue?vue&type=template&id=3721dc6e&scoped=true"
import script from "./DeletedUsersPage.vue?vue&type=script&lang=ts"
export * from "./DeletedUsersPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3721dc6e",
  null
  
)

export default component.exports